import {
  ACTION_GET_RECOVERFORGOTTENPASSWORD,
  ACTION_POST_VALIDATETOKEN,
  ACTION_GET_RESENDTOKEN
} from "@/views/recover_forgotten_password/store/types/types.js";

import Swal from 'sweetalert2';
import EventBus from '@/utils/event_bus.js';
import { recoverForgottenPass } from "../../../services";

const actions = {
  [ACTION_GET_RECOVERFORGOTTENPASSWORD]: ({ state }, email) => {
    return new Promise((resolve, reject) => {
      try {
        state.loadingValidationEmail = true;

        const idGroup = sessionStorage.getItem("idGroup");

        recoverForgottenPass.getValidationEmail({ idGroup, email })
          .then(async resp => {
            if (resp.data.payload != null) {
              sessionStorage.setItem('idUsuario', resp.data.payload.userId);
              await Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Se ha enviado un código de confirmación al correo electrónico ingresado',
                showConfirmButton: false,
                timer: 4500
              });
              EventBus.$emit('modal-validateEmail', resp.data.payload.tokenTime);
              resolve(resp.data);
            }
          })
          .catch(error => {
            reject(error);
            
          })
          .finally(() => {
            state.loadingValidationEmail = false;
          });
      } catch (error) {
        console.error("Error en la solicitud:", error);
        reject(error);
      }
    });
  },

  [ACTION_POST_VALIDATETOKEN]: ({ state }, code) => {
    return new Promise((resolve, reject) => {
      try {
        const idGroup = sessionStorage.getItem("idGroup");
        const idUsuario = parseInt(sessionStorage.getItem("idUsuario")); 
        const idEmpresa = sessionStorage.getItem("idEmpresa");
  
        recoverForgottenPass.postValidateToken({idGroup, idEmpresa, idUsuario, code })
          .then(async resp => {
              await Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Código válido',
                showConfirmButton: false,
                timer: 2000
              });
              EventBus.$emit('modal', true);
              resolve(resp.data);
          })
          .catch(error => {
            reject(error);
          })
          .finally(() => {
            state.loadingValidationEmail = false;
          });
      } catch (error) {
        console.error("Error en la solicitud:", error);
        reject(error);
      }
    });
  },
 
  [ACTION_GET_RESENDTOKEN]: ({ state }) => {
    return new Promise((resolve, reject) => {
      try {
        state.loadingValidationEmail = true;

        const idGroup = sessionStorage.getItem("idGroup");
        const userId = sessionStorage.getItem("idUsuario");

        recoverForgottenPass.getResendToken({ idGroup, userId })
          .then(async resp => {
            await Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: "Se ha reenviado un código de confirmación al correo electrónico ingresado",
              showConfirmButton: false,
              timer: 4500
            });
            EventBus.$emit('modal-validateEmail', resp.data.payload.tokenTime);
            resolve(resp);
          })
          .catch(error => {
            reject(error);
            
          })
          .finally(() => {
            state.loadingValidationEmail = false;
          });
      } catch (error) {
        console.error("Error en la solicitud:", error);
        reject(error);
      }
    });
  },
}

export default actions